import Vue from 'vue';
import Component from 'vue-class-component';

import HintMessage from 'components/HintMessage';

import CatalogReservationConfigHeader from 'components/Catalog/CatalogReservationConfigHeader';
import CatalogLocationInfo from 'components/Catalog/CatalogLocationInfo';
import SpinnerLoading from 'common/components/SpinnerLoading';

import { getReservationsEmailFromTld } from 'common/services/utils/getLastTld';

@Component({
  props: {
    code: {
      type: String,
      required: true,
    },
    activity: {
      type: Object,
      required: true,
    },
    categoryColor: {
      type: String,
      required: true,
    },
    contactInfoList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    CatalogReservationConfigHeader,
    CatalogLocationInfo,
    HintMessage,
    SpinnerLoading,
  },
})
export default class CatalogReservationConfigManualComponent extends Vue {
  get reservationEmail() {
    return getReservationsEmailFromTld();
  }
}
